import React from 'react';
import { Link } from 'react-router-dom';

const MenuItem = ({ label, href, isActive, isHash, className = '', noWrapper = false, onClick }) => {
  const baseClasses = 'inline-block px-3 py-2 text-base font-bold transition-colors';
  const activeClasses = isActive ? 'text-orange-600' : 'text-gray-800 hover:text-orange-600';
  const combinedClasses = `${baseClasses} ${activeClasses} ${className}`.trim();

  if (isHash) {
    return (
      <a 
        href={href} 
        className={combinedClasses}
        onClick={(e) => {
          e.preventDefault();
          const element = document.querySelector(href);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
          onClick?.(e);
        }}
      >
        {label}
      </a>
    );
  }

  const content = (
    <Link 
      to={href} 
      className={combinedClasses}
      onClick={onClick}
    >
      {label}
    </Link>
  );

  if (noWrapper) {
    return content;
  }

  return <li className="list-none">{content}</li>;
};

export default MenuItem;